<script setup lang="ts">
import GroupStatusComponent from './GroupStatusComponent.vue';
import { useModal, NFlex, NButton } from 'naive-ui';
import { h } from 'vue'

const modal = useModal()
const props = defineProps<{
  groupId: number | string
}>()

function showGroupStatusModal() {
  modal.create({
    title: 'Status',
    preset: 'card',
    style: {
      width: '1000px'
    },
    content: () => h(GroupStatusComponent, { groupId: Number(props.groupId) }),
    action: () => h(NFlex, {}, () => [
      h(NButton, {
        onClick: () => modal.destroyAll()
      }, {
        default: () => 'Close'
      })
    ]),
  })
}
</script>

<template>
  <n-button @click="showGroupStatusModal">Change status</n-button>
</template>